import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-clothing-loss-modal',
  templateUrl: './clothing-loss-modal.component.html',
  styleUrls: ['./clothing-loss-modal.component.css']
})
export class ClothingLossModalComponent {
  public itemName = '';
  public unitNumber = 0;
  public description = '';

  constructor(public activeModal: NgbActiveModal) {}

  setValues(itemName: string, description: string, unitNumber?: number): void {
    this.itemName = itemName;
    this.unitNumber = unitNumber || 0;
    this.description = description || '';
  }

  hasUnitNumber(): boolean {
    return this.unitNumber > 0;
  }

  confirm(): void {
    if (!this.isDescriptionValid()) {
      return;
    }
    this.activeModal.close(this.description.trim());
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  isDescriptionValid(): boolean {
    return !!this.description && !!this.description.trim().length;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/clothing-loss-modal.component.ts